import { useState, useRef, useMemo } from "react";
import Image from "next/image";
import { truncate } from "lodash";
import { motion } from "framer-motion";
import cn from "classnames";
import { landingPageTypes } from "@/constant";
import { useOnClickOutside } from "@/hooks";
import { IHomePageTypeButton } from "@/types/stateTypes";
import { IoIosArrowForward } from "react-icons/io";
import { When } from "@/components/common/When";
import cls from "@/components/page-modules/home-page/GenerateTypes/TypesButton/TypesButton.module.scss";
import { SolutionsMenuSizeType } from "@/types/all.types";
import { useMenuSize } from "@/hooks/common/useMenuSize";
const SolutionsTypeButton = () => {
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [isDrop, setIsDrop] = useState(false);
  useOnClickOutside(dropdownRef, () => {
    setIsDrop(false);
  });
  const sizeToTypeCount: Record<SolutionsMenuSizeType, number> = {
    XL: 8,
    L: 7,
    M: 6,
    S: 4,
    default: 9
  };
  const size = useMenuSize();
  const typeCount = sizeToTypeCount[size] || sizeToTypeCount.default;
  const [mainTypes, filteredTypes] = useMemo(() => {
    const main = landingPageTypes.slice(0, typeCount);
    const filtered = landingPageTypes.slice(typeCount);
    return [main, filtered];
  }, [typeCount]);
  return <div className={cn(cls.wrapper, cls.inSolutions)} data-sentry-component="SolutionsTypeButton" data-sentry-source-file="SolutionsTypeButton.tsx">
      <div className={cls.list}>
        {mainTypes.map(({
        type,
        landingPageTitle
      }) => {
        return <a key={type} data-cy="typesButton" className={cn(cls.item)} href={`#${type}`}>
              <div className={cn(cls.mainIcon, cls.icon)}>
                <Image width={14} height={14} src={`/types/${type}.svg`} alt="Type icon" />
              </div>
              <div className={cn(cls.hoverIcon, cls.icon)}>
                <Image width={14} height={14} src={`/types/filled/${type}.svg`} alt="Hover type icon" />
              </div>
              <span>
                {truncate(landingPageTitle, {
              length: 9,
              omission: "."
            })}
              </span>
            </a>;
      })}

        <div className={cls.moreBtn} ref={dropdownRef} data-cy="more" onClick={() => setIsDrop(!isDrop)}>
          More
          <motion.div animate={{
          rotate: !isDrop ? 90 : 270
        }} data-sentry-element="unknown" data-sentry-source-file="SolutionsTypeButton.tsx">
            <IoIosArrowForward color={"#0A9396"} size={16} data-sentry-element="IoIosArrowForward" data-sentry-source-file="SolutionsTypeButton.tsx" />
          </motion.div>
          <When condition={isDrop} data-sentry-element="When" data-sentry-source-file="SolutionsTypeButton.tsx">
            <div className={cls.dropdownContainer}>
              <motion.div className={cls.dropdownList} animate={{
              height: !isDrop ? 0 : 300,
              opacity: !isDrop ? 0 : 1,
              visibility: !isDrop ? "hidden" : "visible"
            }} data-sentry-element="unknown" data-sentry-source-file="SolutionsTypeButton.tsx">
                {filteredTypes.map((item: IHomePageTypeButton) => {
                return <a href={`#${item.type}`} key={item.type}>
                      <Image width={14} height={14} src={`/types/${item.type}.svg`} alt="Type icon" />
                      <span>{item.landingPageTitle}</span>
                    </a>;
              })}
              </motion.div>
            </div>
          </When>
        </div>
      </div>
    </div>;
};
export default SolutionsTypeButton;